import { authApi } from "./authApi";

const itemApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllItems: builder.query({
      query: ({ page = 1, name, status, itemCategory, itemVendor }) => {
        const params = new URLSearchParams();

        params.append("page", page);

        if (name) params.append("name", name);
        if (status) params.append("status", status);
        if (itemCategory) params.append("itemCategory", itemCategory);
        if (itemVendor) params.append("itemVendor", itemVendor);

        return `/item?${params.toString()}`;
      },
      providesTags: ["Items"],
    }),

    getSingleItem: builder.query({
      query: (id) => ({
        url: `/item/${id}`,
        method: "GET",
      }),
      providesTags: ["Items"],
    }),

    createItem: builder.mutation({
      query: (formData) => ({
        url: "/item",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Items"],
    }),

    updateItem: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/item/${id}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["Items"],
    }),

    deleteItem: builder.mutation({
      query: (id) => ({
        url: `/item/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Items"],
    }),
  }),
});

export const {
  useGetAllItemsQuery,
  useGetSingleItemQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
} = itemApi;
